
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LaunchButton from './LaunchButton';
import { cn } from '@/lib/utils';
import { redirectToChatApp } from '@/utils/redirectUtils';

interface NavbarProps {
  className?: string;
}

const Navbar: React.FC<NavbarProps> = ({ className }) => {
  const navigate = useNavigate();

  const navigateToPricing = () => {
    // Use smooth scrolling to the pricing section
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleStartNow = async () => {
    // Directly redirect to chat app
    await redirectToChatApp('', '');
  };

  return (
    <div className="w-full">
      <nav className={cn("flex items-center justify-between py-4 px-6 md:px-12", className)}>
        <div className="flex items-center">
          <Link to="/" className="text-xl font-bold text-foreground flex items-center">
            <span className="gradient-text">Krix AI</span>
          </Link>
        </div>
        
        <div className="hidden md:flex items-center space-x-8">
          <a href="#features" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Features</a>
          <a href="#pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Pricing</a>
          <a href="#faq" className="text-sm text-muted-foreground hover:text-foreground transition-colors">FAQ</a>
        </div>
        
        <div className="flex items-center gap-3">
          <LaunchButton variant="ghost" size="sm" onClick={() => navigate('/checkout')}>
            Compare Plans
          </LaunchButton>
          <LaunchButton variant="cta" size="sm" onClick={handleStartNow}>
            Login
          </LaunchButton>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
